import { render, staticRenderFns } from "./FilemanagerMenuBadge.vue?vue&type=template&id=2f0b886e&"
import script from "./FilemanagerMenuBadge.vue?vue&type=script&lang=js&"
export * from "./FilemanagerMenuBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports